import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import logoIcon from "../images/logoOnly.png";

export default function Layout({ children }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    document.getElementById(targetId)?.scrollIntoView({ behavior: "smooth" });
    setIsMenuOpen(false);
  };

  return (
    <div className="flex flex-col min-h-screen font-[Poppins]">
      <header 
        className="sticky top-0 z-50 px-4 lg:px-6 h-18 flex items-center justify-between"
        style={{
          background: `#141836`
        }}
      >
        <div className="flex items-end gap-3 h-12 my-2">
          <img 
            src={logoIcon}
            alt="Logo Huemul" 
            className="object-contain h-full w-auto"
          />
          <h1 
            className="font-logistica text-3xl tracking-wider whitespace-nowrap"
            style={{
              lineHeight: '0.85',
              letterSpacing: '0.08em',
              color: 'white',
              fontWeight: '400',
              paddingBottom: '1px',
            }}
          >
            LOGÍSTICA HUEMUL
          </h1>
        </div>

        {/* Mobile menu button */}
        <button
          className="lg:hidden text-white"
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            {isMenuOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center gap-4 sm:gap-6 font-[Poppins]">
          {location.pathname === "/" ? (
            <>
              <a
                href="#servicios"
                className="text-sm font-medium hover:underline underline-offset-4 text-white/80 hover:text-white transition-colors"
                onClick={(e) => handleNavClick(e, "servicios")}
              >
                Servicios
              </a>
              <a
                href="#contacto"
                className="text-sm font-medium hover:underline underline-offset-4 text-white/80 hover:text-white transition-colors"
                onClick={(e) => handleNavClick(e, "contacto")}
              >
                Contacto
              </a>
            </>
          ) : (
            <NavLink
              to="/"
              className="text-sm font-medium hover:underline underline-offset-4 text-white/80 hover:text-white transition-colors"
            >
              Inicio
            </NavLink>
          )}
          <NavLink
            to="/blogs"
            className="text-sm font-medium hover:underline underline-offset-4 text-white/80 hover:text-white transition-colors"
          >
            Blog
          </NavLink>
          <a
            href="https://huemul.buhoonline.com/inicio.aspx"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-medium px-4 py-1.5 bg-white text-[#141836] rounded hover:bg-white/90 transition-colors"
          >
            Autogestión
          </a>
        </nav>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="absolute top-full left-0 right-0 bg-[#141836] lg:hidden flex flex-col py-4 shadow-lg font-[Poppins]">
            {location.pathname === "/" ? (
              <>
                <a
                  href="#servicios"
                  className="px-4 py-3 text-sm font-medium text-white hover:text-white transition-colors border-b border-white/10"
                  onClick={(e) => handleNavClick(e, "servicios")}
                >
                  Servicios
                </a>
                <a
                  href="#contacto"
                  className="px-4 py-3 text-sm font-medium text-white hover:text-white transition-colors border-b border-white/10"
                  onClick={(e) => handleNavClick(e, "contacto")}
                >
                  Contacto
                </a>
              </>
            ) : (
              <NavLink
                to="/"
                className="px-4 py-3 text-sm font-medium text-white hover:text-white transition-colors border-b border-white/10"
                onClick={() => setIsMenuOpen(false)}
              >
                Inicio
              </NavLink>
            )}
            <NavLink
              to="/blogs"
              className="px-4 py-3 text-sm font-medium text-white hover:text-white transition-colors border-b border-white/10"
              onClick={() => setIsMenuOpen(false)}
            >
              Blog
            </NavLink>
            <a
              href="https://huemul.buhoonline.com/inicio.aspx"
              target="_blank"
              rel="noopener noreferrer"
              className="mx-4 mt-3 py-2.5 text-sm font-medium text-[#141836] bg-white rounded text-center hover:bg-white/90 transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Autogestión
            </a>
          </nav>
        )}
      </header>

      <main className="flex-1">
        {children}
      </main>

      <footer className="bg-gray-900 text-white py-6 font-[Poppins]">
        <div className="container mx-auto px-4 text-center">
          <p className="text-sm">
            © {new Date().getFullYear()} Logística Huemul - Todos los derechos reservados
          </p>
        </div>
      </footer>
    </div>
  );
} 